import CustomModal from '@src/components/Elements/CustomModal/CustomModal'
import GrabButton from '../GrabButton/GrabButton'
import InfoIcon from '@src/components/Bounties/Bounty/BountyContent/BountyContent.info'
import { useBounties } from '@src/context/BountiesContext'
import BountySubtitle from '../Bounty.subtitle'
import { ModalContent, ModalExtendedInfo, ModalHeading, ModalLink, ModalText } from './BountyModal.styled'
import { BountyModalProps } from './BountyModal.types'
import { usePostHog } from 'posthog-js/react'
import { isUserLoggedIn } from '@src/utils/functions'
import { useDispatch } from 'react-redux'
import { open } from '@src/reducers/authModal.reducer'
import StarRating from '../BountyContent/BountyContent.star'

const BountyModal = ({ isOpen, onClose, bountyId, type, openInfoModal }: BountyModalProps) => {
  const isLoggedIn = isUserLoggedIn()
  const dispatch = useDispatch()
  const posthog = usePostHog()
  const { bounties, grabNewBounty, refetchCampaigns } = useBounties()
  const bounty = bounties?.find((b) => b.bountyId === bountyId)

  const grabBountyClickHandler = () => {
    if (!bountyId) return

    if (!isLoggedIn) {
      onClose()
      dispatch(open({ tab: 'Login' }))
      return
    }

    onClose()
    grabNewBounty(bountyId)
    posthog.capture('bounties_grab_clicked')

    // load bounty menu item with some delay
    setTimeout(() => {
      refetchCampaigns()
    }, 2000)
  }

  if (!bounty) return null

  const renderContent = () => {
    switch (type) {
      case 'grab':
        return (
          <>
            <ModalHeading>
              <BountySubtitle subtitle={bounty.subtitle} />
            </ModalHeading>
            <ModalText>
              Do you wish to activate this bounty? Make sure you read{' '}
              <ModalLink onClick={openInfoModal}>the rules</ModalLink> before you accept.
            </ModalText>
            <GrabButton text="START BOUNTY" onClick={grabBountyClickHandler} />
          </>
        )
      case 'info':
        return (
          <>
            <StarRating rating={bounty.rating} disabled={false} size="lg" />
            <ModalExtendedInfo>{bounty.extendedInfo}</ModalExtendedInfo>
          </>
        )
      default:
        return null
    }
  }

  const heading = type === 'grab' ? bounty.title.toUpperCase() : 'What are bounties?'
  const leftIcon = type === 'info' ? <InfoIcon /> : null

  return (
    <CustomModal isOpen={isOpen} onClose={onClose} heading={heading} leftIcon={leftIcon}>
      <ModalContent>{renderContent()}</ModalContent>
    </CustomModal>
  )
}

export default BountyModal
